import React from "react";

export const DatePickerCustomInput = React.forwardRef((props: any, ref: any) => {

    return props.value ?
        (<input onClick={props.onClick} value={props.value} type="text" readOnly={true} ref={ref} />) :
        (<input onClick={props.onClick} value="Klik voor datum selectie" type="text" readOnly={true} ref={ref} />)
})
